var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorite-badge",attrs:{"title":[
    _vm.isGameFavorite ? _vm.$t('favorite.title.remove') : _vm.$t('favorite.title.add') ]}},[_c('div',{staticClass:"favorite bg-img clickable",class:[_vm.isGameFavorite ? 'active' : '', _vm.loading ? 'pulsating' : ''],on:{"click":_vm.handleFavoriteClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }